import axios from 'axios'
import { getStorage,clearStorage } from "@/common/utils/localStorage";
import {  Message } from 'element-ui'
import Router from '@/router/index'

const baseUrl = '/EncryptApi/api/';

// axios 配置
let instance = axios.create({  
  baseURL: baseUrl,
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    'Content-Type': 'application/json',
  }, //配置请求头
  timeout: 120000
  //开启cookie支持
  //,withCredentials:true
})

// 请求拦截器
instance.interceptors.request.use(config => {
  // 在发送请求之前做些什么，比如传token
  if(getStorage('ticket')){
    config.headers.Authorization = 'BasicAuth ' + getStorage('ticket');
  }
  return config;
}, error => {
  return Promise.reject(error)
})

instance.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  return response;
}, function (error) {
  if(error.response && error.response.status==401){
    clearStorage();
    Message.error({
          message: '登录过期,请重新登录'
    });
    Router.push({path: '/login'});
  } else {
    return Promise.reject(error);
  }  
})

export {baseUrl};

export function request(method, url, requestData = {}, headers = {}) {
  return new Promise((resolve, reject) => {
    instance({
      method: method || 'POST',
      url: url,
      data: requestData.data,
      params: requestData.params,
      headers: headers || {'Content-Type':'application/x-www-form-urlencoded;'}
    })
    .then(response => {
      if(!response || !response.data) {
        return;
      }
      let dataType = Object.prototype.toString.call(response.data)
      
      if (dataType === '[object String]') {
        resolve(JSON.parse(response.data));        
      } else if (dataType === '[object Object]') {
        resolve(response.data)
      } else {
        resolve(response.data)
      }
    })
    .catch(err => {
      reject(err)
    })
  })
}


// WEBPACK FOOTER //
// ./src/common/http/axios.js